import React from 'react';
import styled from 'styled-components'
import PropTypes from 'prop-types';
import {Button, Card, Flex, Heading} from 'rebass'
import {AdaptedInput, AdaptedQuill, AdaptedSwitch} from "./FormField";
import {Field, Form} from 'react-final-form'

import {buttonMarginTop, PopupWrapper} from "./styles";

const required = value => (value ? undefined : 'Required')


const DescriptionWrapper = styled(Card)`
	min-height: 150px;
	.ql-editor {
		min-height: 275px;
		max-height: 275px;
		overflow: auto;
	}
	.ql-toolbar.ql-snow {
	border: none;
	}
	.ql-container.ql-snow {
	border: none;
	}
`

const NewCalendarSchedule = props => {
	const {onSubmit, toggleOverlay, initialValues} = props;

	let title = 'New Schedule'
	if(initialValues.name){
		title = initialValues.name
	}
	return (
		<PopupWrapper>
			<Form
				onSubmit={onSubmit}
				initialValues={initialValues}
				render={({ handleSubmit, form, submitting, pristine, values }) => {
					return (
						<form id="exampleForm" onSubmit={handleSubmit}>
							<Flex flexDirection={'row'} justifyContent={'space-between'}>
							<Heading>{title}</Heading>

								<Flex flexDirection={'row'}>
									<Heading as={'h5'} pr={2}>Activate</Heading>
									<Field
										name={'activated'}
										component={AdaptedSwitch}
										type={'checkbox'}
										/>
								</Flex>
							</Flex>
							<Button variant={'main'} m={1} mt={buttonMarginTop}
							        bg={!values.name ? 'meta' : 'green'}
							        disabled={!values.name}
							        type="submit"

							>
								Save
							</Button>
							<Button variant={'main'} m={1} mt={buttonMarginTop} bg={'gray'} onClick={(e) =>{
								e.preventDefault();
								form.reset()
								toggleOverlay()
							}}>Cancel</Button>

							<Heading as={'h5'} mt={3}>Name</Heading>
							<Card boxShadow={'main'}>

								<Field
									name="name"
									component={AdaptedInput}
									type="text"
									placeholder="Name goes here..."
									validate={required}
								/>
							</Card>


							<Heading as={'h5'} mt={3}>Details</Heading>
							<DescriptionWrapper boxShadow={'main'}>

								<Field
									name="details"
									component={AdaptedQuill}
									placeholder="Details goes here..."
								/>
							</DescriptionWrapper>
						</form>
					)
				}}
			/>
		</PopupWrapper>
	);
};

NewCalendarSchedule.propTypes = {
	onSubmit: PropTypes.func,
	toggleOverlay: PropTypes.func,
	initialValues: PropTypes.object
};

NewCalendarSchedule.defaultProps = {
	onSubmit: (values) => console.log('Category values', values),
	toggleOverlay: () => console.log("Closed overlay"),
	initialValues: {activated: false, details: ''}
};


export default NewCalendarSchedule;
